export const TemplateActionTypes = {
  Edit: "edit"
  // View: "view"
};
